// The markets Neko Lens is live in. Everything else stays dark, and the
// operator toggle can only ever narrow this list, never widen it.
const nekoLensAvailableCountryCodes = ["SE", "GB"];

export function isNekoLensCountry(
  countryCode: string | null | undefined
): boolean {
  return (
    countryCode != null &&
    nekoLensAvailableCountryCodes.includes(countryCode.toUpperCase())
  );
}

// Screens without a visit in scope (Settings) only know the clinic from the
// location cookie, where the site id carries the market as its prefix:
// "SE-ARN12", "GB-LHR01".
export function isNekoLensSite(siteId: string | null | undefined): boolean {
  return isNekoLensCountry(siteId?.split("-")[0]);
}
